export default __webpack_public_path__ + "5966df28c47f438aef6470b879ae6f4f.svg";